/* eslint-disable react/prop-types */
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {useNavigate } from "react-router-dom";
const CategoryContent = (props) => {
  const { categoryData } = props;
  const navigate = useNavigate();

  return (
    <div
      className=""
      data-aos="fade-zoom-in"
      data-aos-offset="200"
      data-aos-easing="ease-in-sine"
      data-aos-duration="600"
    >
      <>
        {categoryData &&
          categoryData.map((category, index) => (
            <React.Fragment key={index}>
              <div
                className=" gap-6 border p-2  flex items-center  my-2 rounded hover:bg-slate-50"
                onClick={() => {
                  category.URL
                    ? navigate("/category-browser", {
                        state: {
                          CategoryName: category?.SubCatName || props.category,
                          Color: category?.Color || props.AppBarColor,
                          URL:category.URL
                        },
                      })
                    : navigate(`${category.SubCatID}`, {
                        state: {
                          category_data: category,
                          Title: category?.SubCatName || props.category,
                          AppBarColor: category?.Color || props.AppBarColor,
                        },
                      });
                }}
              >
                <p
                  style={{
                    background: category.Color,
                  }}
                  className={`w-[25vh]  h-[7vh] md:w-[3.2rem]   float-left rounded-md flex items-center justify-center `}
                >
                  <FontAwesomeIcon
                    icon={category.SubCatIcon}
                    color="white"
                    className="text-base lg:text-2xl  md:text-2xl"
                  />
                </p>

                <div className="float-left w-[80%] md:w-[70%]">
                  <p className="w-[93vh] text-base md:text-base md:font-normal  text-black font-light mb-1 md:mb-0">
                    {category.SubCatName}
                  </p>
                  <p
                    className="w-[93vh]  text-sm font-light mb-0 md:text-sm md:font-normal "
                    style={{
                      color: category.Color,
                    }}
                  >
                    {category.SubCatNameTwo}
                  </p>
                </div>
              </div>
            </React.Fragment>
          ))}
      </>
    </div>
  );
};

export default CategoryContent;
